<template>
  <div class="payment-modal">

    <div class="secondary-menu-header">
      <i class="back" @click="closeModal()"></i>
      <p class="logo-tagline">
        BUDDY<span>PRO</span>
      </p>
    </div>
    <div class="payment-modal-body">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'

export default {
  props: [],
  mixins: [
    require('@general/lib/mixin').default
  ],
  computed: {
    ...mapGetters({
    })
  },
  methods: {
    ...mapActions([
    ]),
    closeModal: function(){
      this.$emit('hideModal')
    }
  },
  data() {
    return {
    }
  }
}
</script>
